import { Injectable } from '@angular/core'
import { Location } from '@angular/common'
import {DssTemaEnum} from "../../enums/dss-tema.enum";

@Injectable({ providedIn: "root" })
export class DesignSystemSigmaService {

  private tagBody: HTMLElement = null;
  private readonly dssClassDark: string = "dss-style-dark";
  private readonly dssClassLight: string = "dss-style-light";
  private readonly notDssClass: string = "not-dss-style";

  constructor(private location: Location) {
    this.tagBody = document.body;
  }

  public isDssLayout(): boolean {
    return this.location.path().includes('/dss/');
  }

  public applyTheme(themeCurrent? : DssTemaEnum): void {
    if (this.isDssLayout()) {
      if(themeCurrent && themeCurrent === DssTemaEnum.LIGHT){ // Add Class "dss-style-light"
        this.resetDssClass();
        this.tagBody.classList.add(this.dssClassLight);
      }else{ // Add Class "dss-style-dark"
        this.resetDssClass();
        this.tagBody.classList.add(this.dssClassDark);
      }
    } else { // Add Class "not-dss-style"
      this.resetDssClass();
      this.tagBody.classList.add(this.notDssClass);
    }
  }

  private resetDssClass(): void {
    if(this.tagBody.classList.contains(this.notDssClass))
      this.tagBody.classList.remove(this.notDssClass);

    if(this.tagBody.classList.contains(this.dssClassDark))
      this.tagBody.classList.remove(this.dssClassDark)

    if(this.tagBody.classList.contains(this.dssClassLight))
      this.tagBody.classList.remove(this.dssClassLight);
  }

}
